import { ReactNode, createContext, useContext } from "react";
import { useFilterPayment } from "./filter-payment.hook";

const FilterPaymentContext = createContext(
  {} as ReturnType<typeof useFilterPayment>
);
export function useFilterPaymentContext() {
  return useContext(FilterPaymentContext);
}

interface FilterPaymentProviderProps {
  children: ReactNode;
}
export function FilterPaymentProvider({
  children,
}: FilterPaymentProviderProps) {
  return (
    <FilterPaymentContext.Provider value={useFilterPayment()}>
      {children}
    </FilterPaymentContext.Provider>
  );
}